module.exports = __webpack_public_path__ + "static/media/tietoja-black.2cce9a5a.svg";